export default __webpack_public_path__ + "static/niche@768_2x-d5619c9ae0f084260b2370e39dc68a1b.webp";